module.exports = "/packs/images/map-close~19940718703fb3b33ac3f94867e9e69b.png";